import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/invoice-items`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/invoice-items/${id}`, options).then((response) => {
    let invoiceItem = jsona.deserialize(response.data);
    delete invoiceItem.links;
    return invoiceItem;
  });
}

function add(invoiceItem) {
  const payload = jsona.serialize({
    stuff: invoiceItem,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/invoice-items`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(invoiceItem) {
  const payload = jsona.serialize({
    stuff: invoiceItem,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/invoice-items/${invoiceItem.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/invoice-items/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
